import React from 'react';
import { computeVisiblePath } from '../utils/branchingPath';

function isAnswerFilled(v) {
  if (Array.isArray(v)) return v.length > 0;
  if (typeof v === 'string') return v.trim() !== '';
  // Likert matrix answers are {row_key: point_key} objects.
  if (v && typeof v === 'object') return Object.values(v).some((x) => x != null && x !== '');
  return v != null && v !== '';
}

/**
 * Sticky answered-questions progress bar for the survey runtime.
 * Counts main questions only — rating follow-up / low-rating sub-answer keys
 * (question_key__*) are ignored so progress matches the advertised question count.
 * With display logic, only currently visible questions count, so the bar
 * re-scales as answers reveal or hide conditional questions.
 */
export default function SurveyProgress({ survey, answers }) {
  const sections = survey?.sections || [];
  const visible = computeVisiblePath(survey, answers);
  const questionCount = sections.reduce(
    (acc, sec) => acc + (sec.questions || []).filter((q) => visible.has(q.question_key)).length,
    0,
  );
  if (questionCount === 0) return null;
  const answeredCount = sections.reduce(
    (acc, sec) =>
      acc +
      (sec.questions || []).filter(
        (q) => visible.has(q.question_key) && isAnswerFilled(answers[q.question_key]),
      ).length,
    0,
  );
  const progressPct = Math.round((answeredCount / questionCount) * 100);
  return (
    <div
      className="survey-progress"
      role="progressbar"
      aria-label="Survey progress"
      aria-valuemin={0}
      aria-valuemax={questionCount}
      aria-valuenow={answeredCount}
      aria-valuetext={`${answeredCount} of ${questionCount} questions answered`}
    >
      <div className="survey-progress-track">
        <div className="survey-progress-fill" style={{ width: `${progressPct}%` }} />
      </div>
      <span className="survey-progress-label">
        {answeredCount} of {questionCount} answered
      </span>
    </div>
  );
}
